<script setup lang="ts">
import InsightSampleCard from '@/components/insights/insight-sample-card.vue';
import { insightSamples } from '@/components/insights/insight-sample-data';

type Emits = {
  register: [];
};
const emit = defineEmits<Emits>();
</script>

<template>
  <div class="insights-sample">
    <div class="banner">
      <div class="banner-desc">
        <p class="c-title-medium--m">
          業務情報を登録すると、あなた向けのヒントがこの形で届きます
        </p>
        <p class="c-text-regular--m banner-note">
          下のサンプルは、業務情報を登録した利用者に届くヒントの例です。
        </p>
      </div>
      <button
        type="button"
        class="banner-action c-btn c-btn--small c-btn--auto c-btn--AnewsPrimary"
        @click="emit('register')"
      >
        業務情報を登録
      </button>
    </div>
    <div v-for="sample in insightSamples" :key="sample.key" class="sample">
      <div class="c-title-medium--m">{{ sample.heading }}</div>
      <InsightSampleCard :sample="sample" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.insights-sample {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.banner {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  padding: 16px;
  border: 1px solid $color-green200;
  border-radius: 4px;
  background: $color-green100;

  .banner-desc {
    display: flex;
    flex-direction: column;
    gap: 4px;

    p {
      margin: 0;
    }
  }

  .banner-note {
    color: $color-gray800;
  }

  .banner-action {
    flex-shrink: 0;
    margin-left: auto;
  }
}

.sample {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
</style>
